const selector_trigger = '.accordion__heading';
const selector_target = '.accordion__content';
const open_marker = 'accordion--open';

let accordionNumber = 0;

function toggleItem(accordion: Element, controlledElement: HTMLElement, open: boolean): void {
	if (open) { // toggle returns true if we are opening the item
		controlledElement.style.display = '';
		controlledElement.style.maxHeight = controlledElement.scrollHeight + "px";

		// Set the fragment to the id of the accordion we are opening
		const url = new URL(window.location.href);
		url.hash = accordion.id;
		history.replaceState(history.state, "", url);
	} else {
		controlledElement.style.maxHeight = "0px";

		// If the current fragment is the id of the accordion we are closing, remove it from the URL
		if (window.location.hash && window.location.hash.substring(1) === accordion.id) {
			const url = new URL(window.location.href);
			url.hash = document.querySelector(`.accordion.${open_marker}`)?.id ?? "";
			history.replaceState(history.state, "", url);
		}
	}
}

function setupIconAndButton(accordionTrigger: HTMLElement, accordionContentId: string) {
	let button: HTMLButtonElement|null;
	if (!(button = accordionTrigger.querySelector<HTMLButtonElement>("button"))) {
		button = document.createElement("button");
		button.innerHTML = `
			<svg width="10" height="10" viewBox="0 0 10 10" role="img" aria-hidden="true">
				<path class="path-V" d="M5,0C4.4,0,4,0.5,4,1V9c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1V1C6,0.5,5.6,0,5,0z" />
				<path class="path-H" d="M9,4H1C0.5,4,0,4.4,0,5c0,0.6,0.5,1,1,1H9c0.6,0,1-0.5,1-1S9.5,4,9,4z" />
			</svg>
		`;

		button.setAttribute("aria-expanded", "false");
		button.setAttribute("aria-controls", accordionContentId);
		while (accordionTrigger.firstChild) {
			button.appendChild(accordionTrigger.firstChild);
		}
		accordionTrigger.appendChild(button);
	}
	return button;
}

function wireUpAccordionGroup(accordionGroup: Element, observe: (element: Element) => void) {
	if (accordionGroup.classList.contains("wp-block-plaudit-accordion-group--js-ready")) {
		return;
	}
	accordionGroup.classList.add("wp-block-plaudit-accordion-group--js-ready");

	accordionGroup.addEventListener('click', event => {
		let button: HTMLButtonElement|null;
		if (event.target instanceof Element && (button = event.target.closest("button"))) {
			const heading = event.target.closest(selector_trigger);
			if (!heading) {
				return;
			}

			const accordion = heading.closest(".wp-block-plaudit-accordion");
			if (accordion) {
				event.preventDefault();
				event.stopPropagation();

				const open = accordion.classList.toggle(open_marker);
				button.setAttribute("aria-expanded", open.toString());

				const controlledElementId = button.getAttribute("aria-controls");
				if (!controlledElementId) {
					return;
				}
				const controlledElement = document.getElementById(controlledElementId);
				if (controlledElement) {
					toggleItem(accordion, controlledElement, open);
				}
			}
		}
	});

	const frag = window.location.hash ? window.location.hash.substring(1) : null;
	for (const accordion of accordionGroup.querySelectorAll(".wp-block-plaudit-accordion")) {
		const accordionContent = accordion.querySelector<HTMLElement>(selector_target);
		const accordionTrigger = accordion.querySelector<HTMLElement>(selector_trigger);
		if (accordionContent && accordionTrigger) {
			observe(accordionContent);
			let accordionId: string|undefined;
			if (!(accordionId = accordion.id).length) {
				accordionId = accordionTrigger.innerText.trim()
					.replace(/([a-z])([A-Z])/g, "$1-$2")
					.replace(/[\s_]+/g, '-')
					.toLowerCase();

				if (!accordionId) {
					accordionId = `p-accordion-${++accordionNumber}`;
				} else if (document.getElementById(accordionId)) { // We use else-if because we only need to check for overlap when we're using an id based on the trigger's contents
					// If the generated id would overlap with the id of another element on the page, we append a suffix to ensure that it remains unique
					accordionId += "-" + (++accordionNumber);
				}
				accordion.id = accordionId;
			}
			if (!accordionContent.id) {
				accordionContent.id = accordionId + "-content";
			}

			const button = setupIconAndButton(accordionTrigger, accordionContent.id);

			accordionContent.addEventListener('transitionend', evt => {
				if (evt.propertyName === 'max-height' && evt.target === accordionContent && accordionContent.style.maxHeight === "0px") {
					accordionContent.style.display = 'none';
				}
			});

			if (accordionId === frag) {
				accordion.classList.toggle(open_marker, true);
				button.setAttribute("aria-expanded", "true");
				accordionContent.style.maxHeight = accordionContent.scrollHeight + "px";
			} else {
				accordionContent.style.maxHeight = "0px";
				accordionContent.style.display = "none"; // This is the equivalent of using JQuery's slideUp function with a duration of 0
			}
		}
	}
}

document.addEventListener('DOMContentLoaded', () => {
	const resizeObserver = new ResizeObserver(entries => {
		for (const entry of entries) {
			if (entry.target instanceof HTMLElement && entry.target.style.maxHeight && entry.target.style.maxHeight !== "0px") {
				entry.target.style.maxHeight = entry.target.scrollHeight + "px";
			}
		}
	});
	const observe = (element: Element) => resizeObserver.observe(element);

	// NOTE: accordion can only be a child of accordionGroup
	document.querySelectorAll('.wp-block-plaudit-accordion-group').forEach(e => wireUpAccordionGroup(e, observe));
	new MutationObserver(mutations => {
		for (const mutation of mutations) {
			for (const addedNode of mutation.addedNodes) {
				if (addedNode instanceof Element) {
					if (addedNode.classList.contains("wp-block-plaudit-accordion-group")) {
						wireUpAccordionGroup(addedNode, observe);
					}
					addedNode.querySelectorAll('.wp-block-plaudit-accordion-group').forEach(e => wireUpAccordionGroup(e, observe));
				}
			}
		}
	}).observe(document, {subtree: true, childList: true});
});
